module.exports = __webpack_public_path__ + "media/src/img/about-bg-a6c33f985caf48755c94ab3cdf3d240d.png";